import { render, staticRenderFns } from "./sidebar.finance.vue?vue&type=template&id=5c564054&"
import script from "./sidebar.finance.vue?vue&type=script&lang=js&"
export * from "./sidebar.finance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports